export default __webpack_public_path__ + "static/media/correct17.636cc75b.mp3";